import { FC } from "react";
import { Skeleton, VStack } from "@chakra-ui/react";
import { FeedCardLayout } from "src/components/feed-card/common/feed-card-layout";

const FEED_CARD_NEWS_SKELETON = "feed-card-news-skeleton";

export const FeedCardNewsSkeleton: FC = () => (
    <FeedCardLayout.Base data-test-id={FEED_CARD_NEWS_SKELETON}>
        <FeedCardLayout.Content>
            <VStack width="100%" spacing={["4px", 1]} align="flex-start">
                <Skeleton h={2} w={["106px", 13]} />
                <VStack w="100%" spacing="4px" align="flex-start">
                    <Skeleton display={["initial", "none"]} h="19px" w={["229px", "90%"]} />
                    <Skeleton h="19px" w={["254px", "100%"]} />
                    <Skeleton h="19px" w={["116px", "160px"]} />
                </VStack>
            </VStack>
        </FeedCardLayout.Content>
    </FeedCardLayout.Base>
);
